import { useMemo } from "react";
import { Flex } from "@chakra-ui/react";
import { ReactComponent as FrontIcon } from "./front-camera.svg";
import { ReactComponent as ExternalIcon } from "./external-camera.svg";
import CameraSection from "./CameraSection";
import SectionDivider from "./SectionDivider";

export default function SectionCameraList({
  cameraList,
  handleCameraChange,
  selectedCameraId
}) {
  const cameraSections = useMemo(() => {
    const sections = {};
    cameraList.forEach((camera) => {
      if (!sections[camera.cameraFacing]) sections[camera.cameraFacing] = [];
      sections[camera.cameraFacing].push(camera);
    });
    return sections;
  }, [cameraList]);

  return (
    <Flex p="16px" width="100%">
      {cameraSections.FRONT && (
        <CameraSection
          isFront
          handleCameraChange={handleCameraChange}
          selectedCameraId={selectedCameraId}
          list={cameraSections.FRONT}
          icon={FrontIcon}
          subtitle="camera.front"
        />
      )}
      {cameraSections.FRONT &&
        (cameraSections.BACK || cameraSections.EXTERNAL) && <SectionDivider />}
      {cameraSections.BACK && (
        <CameraSection
          isBack
          handleCameraChange={handleCameraChange}
          selectedCameraId={selectedCameraId}
          list={cameraSections.BACK}
          subtitle={
            cameraSections.BACK.length > 2
              ? "camera.backCameras"
              : "camera.back"
          }
        />
      )}
      {cameraSections.BACK && cameraSections.EXTERNAL && <SectionDivider />}
      {cameraSections.EXTERNAL && (
        <CameraSection
          isExternal
          icon={ExternalIcon}
          handleCameraChange={handleCameraChange}
          selectedCameraId={selectedCameraId}
          list={cameraSections.EXTERNAL}
        />
      )}
    </Flex>
  );
}
